export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref14826.6bd1a975.jpg";